export default __webpack_public_path__ + "static/media/home-back.da0a6b80.jpg";